<template>
  <div id="searchDataByStudent">
    <!-- 学生查询信息(type 0 查询成绩  1 查询录取   2 准考证打印) -->
    <div class="PC">
      <div class="top"><img src="../assets/img/logo2.png" alt="" /></div>
      <div class="content">
        <div class="dialog-title">
          {{ data.title }}
          <span
            v-if="type == '0' && fileData.name != ''"
            style="
              font-size: 13px;
              font-weight: normal;
              color: #fa6305;
              cursor: pointer;
            "
            >附件下载:<span @click="openFile">{{ fileData.name }}</span></span
          >
        </div>
        <div class="goBack" @click="goBack()">
          <i class="el-icon-d-arrow-left"></i>
          返回
        </div>
        <!-- 申请状态:验证身份,重置密码 -->
        <div class="verification">
          <div class="verification_outer">
            <div class="ver1">
              <div class="ver1_l">
                <div class="ver1_l_c"></div>
              </div>
              <div class="ver1_center"></div>
              <div :class="{ ver1_l: true, ver1_l_bg: data.status == '0' }">
                <div
                  :class="{ ver1_l_c: true, ver1_l_c_bg: data.status == '0' }"
                ></div>
              </div>
            </div>
            <div class="ver2">
              <span>验证身份</span>
              <span class="ver_word">查询结果</span>
            </div>
          </div>
        </div>
        <!-- 身份信息查询 -->
        <div class="dialog-content" v-if="data.status == '0'">
          <div
            :class="{ line: true }"
            v-for="(item, index) in data.list"
            :key="index"
          >
            <div :class="{ value: true, column_value: flag == '2' }">
              <div class="title">{{ item.title }}</div>
              <div class="dd">
                <el-input
                  v-model="item.value"
                  :placeholder="'请输入' + item.title"
                  clearable
                ></el-input>
              </div>
            </div>
          </div>
          <div class="dialog-but">
            <div class="title"></div>
            <div class="valuebtn" @click="queryStatus">
              <span>下一步</span>
            </div>
          </div>
        </div>
        <!-- 审核通过 -->
        <div class="dialog-content" v-if="data.status == '1'">
          <div
            :class="{ line: true }"
            v-for="(item, index) in data.showList"
            :key="index"
          >
            <div :class="{ value: true, column_value_show: flag == '2' }">
              <div class="title">{{ item.title }}</div>
              <div
                :class="{
                  dd: true,
                  enrollClass:type != '0' && item.value == '1',
                  onEnrollClass:type != '0' && item.value == '0',
                }"
                v-if="item.type == 'text'"
              >
                {{
                 type != '0' ?(item.value == "0"
                    ? "未录取"
                    : item.value == "1"
                    ? "拟录取"
                    : item.value) : item.value
                }}
              </div>
              <div
                v-if="item.type == 'file'"
                :class="{
                  dd: true,
                  enrollClass: item.value == '1',
                  onEnrollClass: item.value == '0',
                }"
                style="cursor: pointer; color: #3b85f5; font-size: 14px"
                @click="openFile1(item)"
              >
                {{ item.showText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as baseData from "@/assets/js/base.js";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      type: 0, // 当前显示的是成绩查询还是录取查询
      data: baseData.returnStudentSearchData(0),
      flag: 0,
      status: "0", //审核状态
      input: "",
      refuseReason: "", //审核状态查询返回的原因

      fileData: {
        name: "",
        path: "",
      },
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
    /* 根据身份证号码查询申请状态 */
    queryStatus() {
      let requestData = {};
      let ts = {
        flag: true,
        msg: "",
      };
      this.data.list.forEach((element) => {
        if (element.value == "") {
          ts.flag = false;
          ts.msg = element.title + "不能为空!";
          return;
        }
        this.$set(requestData, element.key, element.value);
      });
      if (!ts.flag) {
        this.$message({
          message: ts.msg,
          type: "error",
        });
        return;
      }

      this.$request("post", this.data.url, requestData, (data) => {
        this.data.showList.forEach((element, index) => {
          if (element.key == "enrollRemark" && data.enrollRemark == "") {
            this.data.showList.splice(index, 1);
          } else if (element.key == "path") {
            element.value = data[element.key];
            element.showText = requestData.name + ".pdf";
          } else {
            element.value = data[element.key];
          }
        });
        this.data.status = "1";
      });
    },
    //返回上一步操作
    goBack() {
      this.$router.push("/dataRequest");
    },
    openFile1(item) {
      const that = this;
      var oReq = new XMLHttpRequest();
      var URL = item.value; // URL 为URL地址
      oReq.open("GET", URL, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "blob",
        });
        saveAs(file, item.showText); // that.name为文件名
      };
      oReq.send();
    },

    openFile() {
      window.open(this.fileData.path, "_blank");
    },

  },
  mounted() {
    this.type = this.$route.query.type;
    this.data = baseData.returnStudentSearchData(this.type);
    if (this.type == "0") {
      this.$request("post", "/getScorePath", null, (data) => {
        this.fileData = data;
      });
    }

    this.start();
  },
};
</script>

<style lang="less" scoped>
#searchDataByStudent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* PC端 */
  .PC {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(245, 245, 245, 1);
    .top {
      width: 25rem;
      height: 5rem;
      box-sizing: border-box;
      margin: 10px 0;

      > img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      border-radius: 10px;
      width: 80%;
      max-width: 1200px;
      height: 70%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      position: relative;
      .dialog-title {
        width: 80%;
        height: 50px;
        line-height: 50px;
        font-size: 17px;
        font-weight: 700;
        border-bottom: 1px solid rgba(204, 204, 204, 1);
      }
      .goBack {
        position: absolute;
        left: 15px;
        top: 15px;
        font-size: 15px;
        &:hover {
          cursor: pointer;
        }
      }

      .verification {
        width: 100%;
        height: 3.75rem;
        display: flex;
        justify-content: center;
        margin: 30px 0 20px 0;
        font-size: 14px;
        .verification_outer {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;

          .ver1 {
            width: 63%;
            display: flex;
            align-items: center;
            margin-right: 17px;
            .ver1_l {
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: rgba(152, 188, 255, 1);
              display: flex;
              justify-content: center;
              align-items: center;

              .ver1_l_c {
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: rgba(51, 125, 255, 1);
              }
            }
            .ver1_l_bg {
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: rgba(229, 229, 229, 1);
              display: flex;
              justify-content: center;
              align-items: center;

              .ver1_l_c_bg {
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: rgba(166, 166, 166, 1);
              }
            }
            .ver1_center {
              flex: 1;
              height: 8px;
              background: rgba(224, 241, 255, 1);
            }
          }
          .ver2 {
            width: 70%;
            display: flex;
            justify-content: space-between;
            > span {
              letter-spacing: 1px;
            }
            .ver_word {
              margin-right: 14px;
            }
          }
        }
      }
      .content_box {
        width: 100%;
        height: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .outer {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .outer_word {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 2px;
            box-sizing: border-box;
            margin: 20px 0 8px 0;
            color: rgba(0, 0, 0, 1);
          }
          .outer_bottom {
            width: 100%;
            height: 15px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin: 15px 0;
            > img {
              width: 9px;
              height: 9px;
            }
            > span {
              font-size: 10px;
              font-weight: 400;
              letter-spacing: 2px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
        .one {
          width: 70px;
          height: 70px;
          box-sizing: border-box;
          margin: 19px 0 26px 0;
        }
        .two {
          font-size: 18px;
          font-weight: 600;
        }
        .three {
          font-size: 12px;
          font-weight: 400;
          box-sizing: border-box;
          margin: 25px 0 20px 0;
          color: rgba(166, 166, 166, 1);
        }
        .four {
          width: 63%;
          display: flex;
          justify-content: center;
          .four_outer {
            width: 100%;
            height: 100px;
            box-sizing: border-box;
            border-radius: 2px;

            display: flex;
            margin-right: 17px;
            .four_left {
              width: 64px;
              height: 100%;
              box-sizing: border-box;
              padding: 16px 0 0 24px;
              > img {
                width: 21px;
                height: 21px;
              }
            }
            .four_right {
              width: 85%;
              height: 100%;
              display: flex;
              flex-direction: column;
              box-sizing: border-box;
              padding-top: 16px;
              align-items: flex-start;

              .rightword {
                font-size: 16px;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                margin-bottom: 4px;
              }
              .rightinfo {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                text-align: left;
              }
            }
          }
          .four_outer_2 {
            background: rgba(246, 255, 237, 1);
            border: 1px solid rgba(183, 235, 143, 1);
          }
          .four_outer_3 {
            background: rgba(255, 251, 230, 1);
            border: 1px solid rgba(255, 229, 143, 1);
          }
        }
        .five {
          width: 63%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
          .five_btn {
            width: 200px;
            height: 32px;
            opacity: 1;
            border-radius: 5px;
            background: rgba(0, 79, 146, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .dialog-content {
        width: 100%;
        height: 90%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        .line {
          width: 100%;
          // height: 2.625rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-top: 10px;

          .value {
            width: 63%;
            height: 43px;
            margin-right: 17px;
            display: flex;
            .title {
              width: 12%;
              min-width: 80px;
              font-size: 14px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin-right: 20px;
            }
            .dd {
              width: 80%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            .onEnrollClass {
              color: red;
              font-size: 1.5rem;
            }
            .enrollClass {
              color: green;
              font-size: 1.5rem;
            }
          }
          .column_value {
            flex-direction: column;
            height: 60px;
            width: 100%;
            margin-right: 0;
            padding: 0 10px;
            box-sizing: border-box;
            > .title,
            > .dd {
              width: 100%;
              height: 30px;
              justify-content: flex-start;
            }
          }
          .line_word {
            width: 63%;
            display: flex;
            margin-top: 5px;
            align-items: center;
            > img {
              width: 12px;
              height: 12px;
            }
            > span {
              margin-left: 5px;
              font-size: 12px;
              font-weight: 400;
              letter-spacing: 2px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
        .dialog-but {
          width: 100%;
          height: 2.8125rem;
          box-sizing: border-box;

          display: flex;
          justify-content: center;
          align-items: flex-start;
          margin: 50px 17px 0 0;
          .valuebtn {
            width: 63%;
            height: 43px;
            background: rgba(7, 80, 139, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            &:hover {
              cursor: pointer;
            }
            > span {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>